import React from "react";
import { render } from "react-dom";
import { client } from "helpers/apolloClientLink";
import { ApolloProvider } from "@apollo/client";
import ShareButtons from "components/ShareButtons";
import Topics from "./Topics";
import "./style.scss";

const ShareButtonContent = ({ landingPage }) => (
  <ShareButtons
    url={`https://chuffed.org/topic/${landingPage.slug}`}
    picture={landingPage.image}
    round={false}
    quote={landingPage.heroDescription}
    emailShareText="Email"
    emailShareSubject="Have you heard about this?"
    emailShareBody="Hi! I thought you might be interested in this campaign -"
    messengerShareText="Messenger"
    whatsappShareText="WhatsApp"
    facebookShareText="Facebook Post"
    twitterShareText="X (Formerly Twitter)"
    blueskyShareText="Bluesky"
    copyText="Copy Url"
    trackingEvent="campaign_shared"
    trackingSource="landing_page_sharebar"
    type="default"
  />
);

window.addEventListener("DOMContentLoaded", () => {
  const landingPage = (global.Chuffed && global.Chuffed.landingPage) || {};
  const countriesCampaigns = (global.Chuffed && global.Chuffed.countries) || {};

  if (document.getElementById("facebook-shares-campaign")) {
    render(
      <ApolloProvider client={client}>
        <ShareButtonContent landingPage={landingPage} />
      </ApolloProvider>,
      document.getElementById("facebook-shares-campaign"),
    );
  }
  if (document.getElementById("country-campaigns")) {
    render(
      <Topics countriesCampaigns={countriesCampaigns} />,
      document.getElementById("country-campaigns"),
    );
  }
});
